import { useQuery } from '@tanstack/react-query';
import parseHtmlToReact from 'html-react-parser';
import { useParams } from 'react-router';

import FadeInAnimation from '../../utils/FadeInAnimation';
import { getLanguageCode } from '../../utils/utils';

import { getEditorialByTagQuery } from '@queries/editorial';
import ErrorBoundary from '@shared/ErrorBoundary';
import VideoPlayer from '@shared/VideoPlayer';

import * as styles from './styles.module.scss';

const TopModule = () => {
  const { locale } = useParams();
  const { data: article } = useQuery(getEditorialByTagQuery('PLAYMAKERS.TOP', getLanguageCode(locale)));

  if (!article) return null;

  return (
    <ErrorBoundary>
      <div className={styles.topcard__section}>
        <FadeInAnimation className='topcard__text' offset={0} delay={0}>
          <h2 className={styles.mainTitle}>{article.title}</h2>
          <h3 className={styles.description}>{parseHtmlToReact(article.htmlDescription ?? '')}</h3>
        </FadeInAnimation>
        <div className={styles.topcard__video}>
          <FadeInAnimation className={styles['topcard__video-wrap']} offset={0} delay={500}>
            {article.mainMedia && <VideoPlayer isAutoPlay={false} className='jw-comp' teaser={article.mainMedia} />}
          </FadeInAnimation>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default TopModule;
